import api from "!../../../../test-qa.dotag.com/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../test-qa.dotag.com/node_modules/css-loader/dist/cjs.js??clonedRuleSet-11.use[1]!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../test-qa.dotag.com/node_modules/laravel-mix/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-11.use[2]!../../../../test-qa.dotag.com/node_modules/vue-loader/lib/index.js??vue-loader-options!./ProjectMarking.vue?vue&type=style&index=0&id=6ca4ffb8&prod&scoped=true&lang=css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};